<div class="modal fade" id="performa_add_company" tabindex="-1" aria-hidden="true">
	<div class="modal-dialog modal-dialog-centered mw-650px">
		<div class="modal-content">
			<div class="modal-header p-3 d-flex justify-content-between bg-secondary">
				<h2>Add Company</h2>
				<div class="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal">
					<i class="ki-duotone ki-cross fs-1">
						<span class="path1"></span>
						<span class="path2"></span>
					</i>
				</div>
			</div>
			<div class="modal-body scroll-y p-10">
				<form class="form" [formGroup]="companyForm" (ngSubmit)="onSubmit()">
					<div class="fv-row row mb-5">
						<div class="col-md-3 d-flex align-items-center">
							<label for="addName" class="fs-7 text-gray-600 required">Name</label>
						</div>
						<div class="col-md-9">
							<div class="fv-row row">
								<div class="col-md-3">
									<select class="form-select h-40px fs-7" formControlName="title" id="adInitialSelect" aria-label="Title" data-kt-select="true" data-placeholder="Title"
										[class.is-invalid]="companyForm.get('title')?.invalid && companyForm.get('title')?.touched">
										<option value="Mr.">Mr.</option>
										<option value="Mrs.">Mrs.</option>
										<option value="Miss">Miss</option>
									</select>
									<div class="invalid-feedback" *ngIf="companyForm.get('title')?.invalid && companyForm.get('title')?.touched">
										<div *ngIf="companyForm.get('title')?.errors?.['required']">Title is required</div>
									</div>
								</div>
								<div class="col-md-9">
									<input type="text" formControlName="name" id="addName" class="form-control h-40px fs-7" placeholder="Name"
										[class.is-invalid]="companyForm.get('name')?.invalid && companyForm.get('name')?.touched" />
									<div class="invalid-feedback" *ngIf="companyForm.get('name')?.invalid && companyForm.get('name')?.touched">
										<div *ngIf="companyForm.get('name')?.errors?.['required']">Name is required</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="fv-row row mb-5">
						<div class="col-md-3 d-flex align-items-center">
							<label for="addCompany" class="fs-7 text-gray-600 required">Company</label>
						</div>
						<div class="col-md-9">
							<input type="text" formControlName="company" id="addCompany" class="form-control h-40px fs-7" placeholder="Company"
								[class.is-invalid]="companyForm.get('company')?.invalid && companyForm.get('company')?.touched" />
							<div class="invalid-feedback" *ngIf="companyForm.get('company')?.invalid && companyForm.get('company')?.touched">
								<div *ngIf="companyForm.get('company')?.errors?.['required']">Company is required</div>
							</div>
						</div>
					</div>
					<div class="fv-row row mb-5">
						<div class="col-md-3 d-flex align-items-center">
							<label for="addAddress" class="fs-7 text-gray-600">Address</label>
						</div>
						<div class="col-md-9">
							<input type="text" formControlName="address" id="addAddress" class="form-control h-40px fs-7" placeholder="Address" />
						</div>
					</div>
					<div class="fv-row row mb-5">
						<div class="col-md-3 d-flex align-items-center">
							<label for="addCity" class="fs-7 text-gray-600">City</label>
						</div>
						<div class="col-md-9">
							<div class="fv-row row">
								<div class="col-md-5">
									<input type="text" formControlName="city" id="addCity" class="form-control h-40px fs-7" placeholder="City" />
								</div>
								<div class="col-md-2 d-flex align-items-center">
									<label for="addState" class="fs-7 text-gray-600">State</label>
								</div>
								<div class="col-md-5 d-flex align-items-center">
									<input type="text" formControlName="state" id="addState" class="form-control h-40px fs-7" placeholder="State" />
								</div>
							</div>
						</div>
					</div>
					<div class="fv-row row mb-5">
						<div class="col-md-3 d-flex align-items-center">
							<label for="addZip" class="fs-7 text-gray-600">Zip</label>
						</div>
						<div class="col-md-9">
							<div class="fv-row row">
								<div class="col-md-5">
									<input type="text" formControlName="zip" id="addZip" class="form-control h-40px fs-7" placeholder="Zip" />
								</div>
								<div class="col-md-2 d-flex align-items-center">
									<label for="addPort" class="fs-7 text-gray-600">Port</label>
								</div>
								<div class="col-md-5 d-flex align-items-center">
									<input type="text" formControlName="port" id="addPort" class="form-control h-40px fs-7" placeholder="Port" />
								</div>
							</div>
						</div>
					</div>
					<div class="fv-row row mb-5">
						<div class="col-md-3 d-flex align-items-center">
							<label for="addCountry" class="fs-7 text-gray-600">Country</label>
						</div>
						<div class="col-md-9">
							<select class="form-select h-40px fs-7" formControlName="country" id="addCountry" aria-label="Select Country" data-placeholder="Select Country">
								<option value="">Select Country</option>
								<option *ngFor="let country of countryList" [value]="country.name">{{ country.name }}</option>
							</select>
						</div>
					</div>
					<div class="fv-row row mb-5">
						<div class="col-md-3 d-flex align-items-center">
							<label for="addEmailID" class="fs-7 text-gray-600 required">Email / Login ID</label>
						</div>
						<div class="col-md-9">
							<input type="email" formControlName="email" id="addEmailID" class="form-control h-40px fs-7" placeholder="Email / Login ID"
								[class.is-invalid]="companyForm.get('email')?.invalid && companyForm.get('email')?.touched" />
							<div class="invalid-feedback" *ngIf="companyForm.get('email')?.invalid && companyForm.get('email')?.touched">
								<div *ngIf="companyForm.get('email')?.errors?.['required']">Email is required</div>
								<div *ngIf="companyForm.get('email')?.errors?.['email']">Please enter a valid email</div>
							</div>
						</div>
					</div>
					<div class="fv-row row mb-5">
						<div class="col-md-3 d-flex align-items-center">
							<label for="addPhone" class="fs-7 text-gray-600">Telephone</label>
						</div>
						<div class="col-md-9">
							<input type="tel" formControlName="phone" id="addPhone" class="form-control h-40px fs-7" placeholder="Telephone" />
						</div>
					</div>
					<div class="fv-row row mb-5">
						<div class="col-md-3 d-flex align-items-center">
							<label for="addMobile" class="fs-7 text-gray-600">Mobile</label>
						</div>
						<div class="col-md-9">
							<input type="tel" formControlName="mobile" id="addMobile" class="form-control h-40px fs-7" placeholder="Mobile" />
						</div>
					</div>
					<div class="fv-row row mb-5">
						<div class="col-md-3 d-flex align-items-center">
							<label for="addFaxNumber" class="fs-7 text-gray-600">Fax</label>
						</div>
						<div class="col-md-9">
							<input type="tel" formControlName="fax" id="addFaxNumber" class="form-control h-40px fs-7" placeholder="Fax" />
						</div>
					</div>
					<div class="fv-row row mb-5">
						<div class="col-md-3 d-flex align-items-center">
							<label for="addSkypeID" class="fs-7 text-gray-600">Skype ID</label>
						</div>
						<div class="col-md-9">
							<input type="text" formControlName="skype_id" id="addSkypeID" class="form-control h-40px fs-7" placeholder="Skype ID" />
						</div>
					</div>
					<div class="fv-row row mb-5">
						<div class="col-md-3 d-flex align-items-center">
						</div>
						<div class="col-md-9">
							<div class="fv-row row">
								<div class="col-md-6">
									<button type="button" class="btn btn-sm btn-light btn-outline w-100" (click)="clearForm()">Clear</button>
								</div>
								<div class="col-md-6">
									<button type="submit" class="btn btn-sm btn-primary w-100 indicator" [disabled]="isLoading">
										<span class="indicator-label" *ngIf="!isLoading">Add Company</span>
										<span class="indicator-progress" *ngIf="isLoading">
											Please wait...
											<span class="spinner-border spinner-border-sm align-middle ms-2"></span>
										</span>
									</button>
								</div>
							</div>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>
</div>

<app-performa-broker-manager-modal></app-performa-broker-manager-modal>
